import stickyItem from './stickyItem';
import stickyContainer from './stickyContainer';

export { stickyItem, stickyContainer };



// WEBPACK FOOTER //
// ./~/vue-xpc/src/mixins/sticky/index.js